import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import Assets from '../../helpers/Assets';
import t from '../../lib/I18n';
import AmazonPayPayment from '../../records/order/AmazonPayPayment';

const AmazonPayPaymentDetails = ({ payment, small }) => (
    <span className={ classnames({ 'payment-details--small': small }) }>
        <img className="payment-details__image payment-details__image--amazon-pay" src={ Assets.assetUrl("images/amazon-pay-only-logo-small.png") } alt="Amazon Pay logo" />
        <span className="payment-details__account-name">{ t('payment.details.amazonPay', { amazonPayAccount: payment.amazonPayAccount }) }</span>
    </span>
);

AmazonPayPaymentDetails.propTypes = {
    payment: PropTypes.instanceOf(AmazonPayPayment).isRequired,
    small: PropTypes.bool
};

AmazonPayPaymentDetails.defaultProps = {
    small: false
};

export default AmazonPayPaymentDetails;



// WEBPACK FOOTER //
// ./src/components/payment/AmazonPayPaymentDetails.js